import { cn } from "@/lib/utils"
import standardLogo from "@/assets/Logo_meatbid_3.png"
import circularLogo from "@/assets/meatbid-logo-circular.png"

interface BrandLogoProps {
  /** Sizing classes like 'h-24' or 'h-16' */
  className?: string
  /** standard (default) or circular variant */
  variant?: "standard" | "circular"
  /** Optional alt text override */
  alt?: string
}

/**
 * BrandLogo - The centralized technical component for the Meatbid brand identity.
 *
 * Implements 'Precision Inversion':
 * - Inverts black outlines to white in dark mode.
 * - Preserves brand green using mathematical hue-rotation.
 * - Smooth 500ms transitions between theme states.
 */
export const BrandLogo = ({
  className,
  variant = "standard",
  alt = "MeatBid Logo",
}: BrandLogoProps) => {
  const logoSrc = variant === "circular" ? circularLogo : standardLogo

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={cn(
        "w-auto transition-all duration-500",
        "dark:brightness-125 dark:contrast-150 dark:hue-rotate-180 dark:invert",
        className
      )}
    />
  )
}

